import { RefObject, useEffect } from "react";

interface UseTextareaAutosizeProps {
  textareaRef: RefObject<HTMLTextAreaElement>;
  value: string;
  minHeightPx: number;
  maxHeightPx: number;
}

export default function useTextareaAutosize({
  textareaRef,
  value,
  minHeightPx,
  maxHeightPx,
}: UseTextareaAutosizeProps) {
  useEffect(() => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "auto";
    const nextHeight = Math.max(
      minHeightPx,
      Math.min(textarea.scrollHeight, maxHeightPx)
    );

    textarea.style.height = `${nextHeight}px`;
    textarea.style.overflowY = textarea.scrollHeight > maxHeightPx ? "auto" : "hidden";
  }, [textareaRef, value, minHeightPx, maxHeightPx]);
}
